'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var AuthService = require('./AuthService.cjs');
var types = require('./types.cjs');
var AbstractAuthProvider = require('./providers/auth/AbstractAuthProvider.cjs');
var FusionAuthSPAAuthProvider = require('./providers/auth/fusionAuth/FusionAuthSPAAuthProvider.cjs');
var AbstractPlatformProvider = require('./providers/platform/AbstractPlatformProvider.cjs');
var BrowserPlatformProvider = require('./providers/platform/BrowserPlatformProvider.cjs');



exports.AuthService = AuthService.AuthService;
exports._unused = types._unused;
exports.AbstractAuthProvider = AbstractAuthProvider.AbstractAuthProvider;
exports.FusionAuthSPAAuthProvider = FusionAuthSPAAuthProvider.FusionAuthSPAAuthProvider;
exports.AbstractPlatformProvider = AbstractPlatformProvider.AbstractPlatformProvider;
exports.BrowserPlatformProvider = BrowserPlatformProvider.BrowserPlatformProvider;
